module.exports = __webpack_public_path__ + "img/weeklytask-icon.ff638c68.png";